// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { withHandlers } from '../../node_module_clones/recompose';

// Selectors
import { getPlatformDetailsSelector } from '../platform/platformSelector';
import { currentBoardInboxActivityCountSelector } from '../element/activity/selectors/boardActivitySelector';

// Component
import Button from '../components/buttons/Button';
import ElementDropTarget from '../element/dnd/elementDropTargets/ElementDropTarget';
import TextActivityIndicator from '../element/activity/TextActivityIndicator';
import { zoomStateContextConsumer } from '../canvas/zoom/ZoomStateContext';

// Drop Utils
import inboxCanDrop from './inboxCanDrop';
import inboxDropLocationFn from './inboxDropLocationFn';
import dragHoverDelayedInteractionDecorator from '../element/dnd/dragHoverDelayedInteractionDecorator';

// Constants
import { DROP_TARGET_TYPES } from '../../common/elements/elementConstants';
import { NATIVE_TYPES } from '../utils/dnd/dragAndDropUtils';

// Styles
import './InboxClosed.scss';

const mapStateToProps = createSelector(
    currentBoardInboxActivityCountSelector,
    getPlatformDetailsSelector,
    (activityCount, platformDetails) => ({ activityCount, platformDetails }),
);

const dropTargetConfig = {
    drop: inboxDropLocationFn,
    canDrop: inboxCanDrop,
    acceptDropTypes: NATIVE_TYPES,
    hoverType: DROP_TARGET_TYPES.INBOX_CLOSED,
};

@connect(mapStateToProps)
@withHandlers({
    handleHoverInteraction:
        ({ openInboxHandler }) =>
        () =>
            openInboxHandler(),
})
@zoomStateContextConsumer
@ElementDropTarget(dropTargetConfig)
@dragHoverDelayedInteractionDecorator
class InboxClosed extends React.Component {
    render() {
        const {
            className,
            openInboxHandler,
            inboxElementIds,
            connectDropTarget,
            isHovered,
            activityCount,
            showNavigationFeedback,
        } = this.props;

        const classes = classNames('InboxClosed', className, {
            hovered: isHovered,
            empty: inboxElementIds.length === 0,
            'pre-open-hover': showNavigationFeedback,
        });

        return (
            <div className={classes} ref={connectDropTarget}>
                <Button onClickFn={openInboxHandler}>
                    <div>
                        <span className="count">{inboxElementIds.length}&nbsp;</span>
                        <span>Unsorted</span>
                    </div>
                </Button>
                {activityCount > 0 ? <TextActivityIndicator>{activityCount}</TextActivityIndicator> : null}
            </div>
        );
    }
}

InboxClosed.propTypes = {
    className: PropTypes.string,
    currentBoardId: PropTypes.string,
    openInboxHandler: PropTypes.func,
    connectDropTarget: PropTypes.func,
    inboxElementIds: PropTypes.array,
    isHovered: PropTypes.bool,
    showNavigationFeedback: PropTypes.bool,
    activityCount: PropTypes.number,
    platformDetails: PropTypes.object,
};

export default InboxClosed;
